const state = {
  paymentDetails: null
}

const mutations = {
  SET_PAYMENT_DETAILS (state, payload) {
    state.paymentDetails = payload
  }
}

const actions = {
  setPaymentDetails ({ commit }, payload) {
    commit('SET_PAYMENT_DETAILS', payload)
  }
}

const getters = {
  getPaymentDetails (state) {
    return state.paymentDetails
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
